export const execute_url = '/statistics/'